export { default as Card } from './Card';
export { default as ShareButtons } from './ShareButtons';
export { default as Image } from './Image';
export { default as BasketBar } from './BasketBar';
export { default as BasketCard } from './BasketCard';
export { default as OrdersCard } from './OrdersCard';
export { default as ReportForm } from './ReportForm';
export { default as LoadingDots } from './LoadingDots';
export { default as ProcessButton } from './ProcessButton';
export { default as ProcessHeader } from './ProcessHeader';
export { default as Header } from './Header';
export { default as RefreshToken } from './ReportForm/RefreshToken';
export { default as Sidebar } from './Sidebar';
export { default as Load } from './Load';
export { default as Modal } from './Modal';

export const standards = {
  colors: {
    green: {
      weak: '#717e30',
      medium: '#62692c',
      strong: '#4a501d',
    },
    red: {
      weak: '#e76756',
      medium: '#cf5648',
      strong:'#a53c34',
    },
    orange: {
      weak:'#edac5d',
      medium:'#df9646',
      strong:'#c27930',
    },
    neutral: {
      weak:'#f2ebe2',
      medium:'#ded3c7',
      strong:'#bcafa4',
    },
  },
};
